import pluralize from "pluralize";

export function setupCustomPluralizations() {
  pluralize.addIrregularRule("event processed", "events processed");
}
